
































import {Component, Prop, Vue} from 'vue-property-decorator';

interface Row {
    title?: string;
    values: string[];
    img?: string;
    images?: string[];
    icon?: string;
}

@Component({
    data: () => {
        const rows: Row[] = [
            {
                values: ['GLAS', 'EDELSTAHL', 'BAMBUS', 'PAPIER', 'PLASTIK'],
                images: ['/../benefits/glas.png', '/../benefits/metall.png', '/../benefits/bambus.png', '/../benefits/papier.png', '/../benefits/plastik.png']
            },
            {
                title: 'WIEDER-<br>VERWENDBARKEIT',
                img: '/../benefits/grüner punkt-schwarz.png',
                values: [
                    '<i class="fas fa-check"></i>',
                    '<i class="fas fa-check"></i>',
                    '<i class="fas fa-check"></i>',
                    '<i class="fas fa-times"></i>',
                    '<i class="fas fa-times"></i>'
                ]

            },
            {
                title: 'UMWELT-<br>FREUNDLICH',
                img: '/../benefits/meer_schwarz.png',
                values: [
                    '<i class="fas fa-check"></i>',
                    '<i class="fas fa-check"></i>',
                    '<i class="fas fa-times"></i>',
                    '<i class="fas fa-times"></i>',
                    '<i class="fas fa-times"></i>'
                ]
            },
            {
                title: 'BRUCHSICHERHEIT',
                icon: 'fas fa-shield-alt',
                values: [
                    '(<i class="fas fa-check"></i>)',
                    '<i class="fas fa-check"></i>',
                    '<i class="fas fa-check"></i>',
                    '<i class="fas fa-check"></i>',
                    '<i class="fas fa-check"></i>'
                ]
            },
            {
                title: 'REINIGUNG',
                img: '/../benefits/wash.png',
                values: [
                    '<i class="fas fa-check"></i>',
                    '<i class="fas fa-check"></i>',
                    '<i class="fas fa-times"></i>',
                    '<i class="fas fa-times"></i>',
                    '<i class="fas fa-times"></i>']
            },
            {
                title: 'GESCHMACKS-<br>NEUTRAL',
                img: '/../benefits/kiss.png',
                values: [
                    '<i class="fas fa-check"></i>',
                    '<i class="fas fa-times"></i>',
                    '<i class="fas fa-times"></i>',
                    '<i class="fas fa-times"></i>',
                    '<i class="fas fa-times"></i>'
                ]
            },
            {
                title: 'PREIS',
                icon: 'fas fa-euro-sign',
                values: ['€ € €', '€ € €', '€ € €', '€ €', '€']
            },
            {
                title: 'LANGLEBIGKEIT',
                icon: 'far fa-clock',
                values: ['+ + +', '+ +', '+ ', '– –', '–']
            }
        ];
        return {
            rows
        };
    }
})
export default class Benefits extends Vue {
    get header() {
        const rows: Row[] = this.$data.rows;
        return rows.filter((r) => !r.title);
    }

    get body() {
        const rows: Row[] = this.$data.rows;
        return rows.filter((r) => r.title);
    }
}
